import { collection, onSnapshot, query } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from './firebaseConfig';
import './game.css';

function Scorecard() {
  const [guests, setGuests] = useState([])
  const [guestScores, setGuestScores] = useState([])
  const [questions, setQuestions] = useState([])
 
  useEffect(() => {
    var temp = [];
    guests.forEach((guest) => {

      var count = 0;

      if (Array.isArray(guest.answers) && guest.answers.length > 0) {
        questions.forEach(question => {
          guest.answers.forEach(answer => {
            if (question.id === answer.questionId) {
              try {
                const questionObject = JSON.parse(question.text)
                if (questionObject.correctAnswerId === answer.answerId) {
                  count++;
                }
              } catch {
                // Ignore malformed questions so the scoreboard can keep running.
              }
            }
          });
        });
      }
      if (count > 0) {
        if(guest.name){
          temp.push({ guestName: guest.name, score: count });
        }
        else{
          temp.push({ guestName: "Anonymous", score: count });
        }
      }

    });

    setGuestScores(temp.sort((a, b) => {

      if (a.score > b.score) {
        return -1;
      }
      if (a.score < b.score) {
        return 1;
      }

      // names must be equal
        return a.guestName.localeCompare(b.guestName);
    }));
    //console.log(temp)
  }, [guests, questions]);

  useEffect(() => {
    const questionCollection = collection(db, 'question');
    const questionsQuery = query(questionCollection);

    var unsub = onSnapshot(questionsQuery, (snapshot) => {
      const updatedQuestions = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));
      setQuestions(updatedQuestions)
    });

    return () => unsub();

  }, []);


  useEffect(() => {

    const guestsCollection = collection(db, 'guest');
    //const guestsQuery = query(guestsCollection, where("answers", "!=", null));
    const guestsQuery = query(guestsCollection);

    // Subscribe to the guests collection for live updates
    const unsubscribe = onSnapshot(guestsQuery, (snapshot) => {
      const updatedGuests = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data()
      }));

      setGuests(updatedGuests)
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="scoreboard">
      <h1>Scoreboard</h1>
      {guestScores.length === 0 && <p className="empty-state">Scores will appear as answers come in.</p>}
      <div className="score-grid">
      {
        guestScores.map((guest, index)=>{
          return (
            <div className="score-card" key={`${guest.guestName}-${index}`}>
              <div className="score-rank">#{index + 1}</div>
              <div className="score-name">{guest.guestName}</div>
              <div className="score-value">{guest.score}</div>
            </div>

          )
        })
      }
      
      </div>
    </div>
  )
}

export default Scorecard
